import { SVGProps, Ref, forwardRef } from 'react'
const SvgArrowRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeWidth={2} d="M13.85 18.65 21 11.5l-7.15-7.15M21 11.5H2" />
  </svg>
)
const ForwardRef = forwardRef(SvgArrowRight)
export default ForwardRef
